export default __webpack_public_path__ + "static/media/xspensr.0e0e1ae5.png";